import React from "react";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
